// src/learnerApi.js
// Học sinh trung tâm mở khoá nội dung học bằng SĐT phụ huynh + tên. Máy chỉ lưu token phiên (không lưu SĐT).
// contentFetch gửi kèm token học sinh và (nếu đang đăng nhập Firebase, ví dụ admin) ID token,
// để máy chủ trả đủ tài liệu, bài tập, lời giải, video. Xem backend/api/learnerAccess.js.
import { getAuth } from "firebase/auth";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const LEARNER_KEY = "mx_learner"; // { token, student: { id, fullName, classes } }
const DEVICE_KEY = "mx_device_id";
export const LEARNER_EVENT = "mx-learner-change";

const readJson = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key) || "null");
  } catch {
    return null;
  }
};

export const getLearner = () => readJson(LEARNER_KEY);
const getToken = () => getLearner()?.token || null;

const setLearner = (value) => {
  try {
    if (value) localStorage.setItem(LEARNER_KEY, JSON.stringify(value));
    else localStorage.removeItem(LEARNER_KEY);
  } catch {}
  window.dispatchEvent(new Event(LEARNER_EVENT));
};

// Mã ngẫu nhiên của trình duyệt này, để giới hạn số lần nhập sai theo từng máy
export const getDeviceId = () => {
  try {
    let id = localStorage.getItem(DEVICE_KEY);
    if (!id) {
      id = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
      localStorage.setItem(DEVICE_KEY, id);
    }
    return id;
  } catch {
    return "";
  }
};

// Gọi API nội dung (khoá học, chuyên đề, đề luyện thi, trắc nghiệm) kèm quyền của người đang xem
export const contentFetch = async (url, options = {}) => {
  const headers = { ...(options.headers || {}) };
  const token = getToken();
  if (token) headers["X-Learner-Token"] = token;
  try {
    const auth = getAuth();
    await auth.authStateReady();
    if (auth.currentUser) headers.Authorization = `Bearer ${await auth.currentUser.getIdToken()}`;
  } catch {}
  return fetch(url, { ...options, headers });
};

// Gọi API cần tài khoản (admin ghi nội dung, hồ sơ / xu của người dùng, thống kê): kèm token Firebase
export const authFetch = contentFetch;

const learnerCall = async (path, { method = "GET", body } = {}) => {
  const response = await fetch(`${API_BASE_URL}/learner${path}`, {
    method,
    headers: {
      "Content-Type": "application/json",
      ...(getToken() ? { "X-Learner-Token": getToken() } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  const data = await response.json().catch(() => ({}));
  return { ok: response.ok, status: response.status, data };
};

// Mở khoá: trả về { ok, message, attemptsLeft }
export const loginLearner = async (phone, name) => {
  try {
    const { ok, data } = await learnerCall("/login", {
      method: "POST",
      body: { phone, name, deviceId: getDeviceId() },
    });
    if (ok) {
      setLearner({ token: data.token, student: data.student });
      return { ok: true, student: data.student };
    }
    return { ok: false, message: data.message || "Không mở khoá được.", attemptsLeft: data.attemptsLeft };
  } catch {
    return { ok: false, message: "Không kết nối được máy chủ, vui lòng thử lại." };
  }
};

export const logoutLearner = async () => {
  try {
    await learnerCall("/logout", { method: "POST" });
  } catch {}
  setLearner(null);
};

// Kiểm tra phiên còn dùng được (học sinh nghỉ học hoặc bị đăng xuất thì xoá khỏi máy)
export const refreshLearner = async () => {
  if (!getToken()) return null;
  try {
    const { ok, status, data } = await learnerCall("/me");
    if (ok) {
      setLearner({ token: getToken(), student: data.student });
      return data.student;
    }
    if (status === 401) setLearner(null);
  } catch {}
  return getLearner()?.student || null;
};

// Ghi việc học (không chờ, lỗi thì bỏ qua). type: xem ACTIVITY_TYPES ở máy chủ.
export const recordActivity = (activity) => {
  if (!getToken()) return;
  learnerCall("/activity", { method: "POST", body: activity }).catch(() => {});
};

export const getMarks = async (prefix) => {
  if (!getToken()) return {};
  try {
    const { ok, data } = await learnerCall(`/marks?prefix=${encodeURIComponent(prefix)}`);
    return ok ? data : {};
  } catch {
    return {};
  }
};

export const setMark = async (refKey, result, title) => {
  const { ok } = await learnerCall("/marks", { method: "PUT", body: { refKey, result, title } });
  return ok;
};
